import { useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStoreActions } from 'easy-peasy';
import { useAuthContext } from 'contexts/AuthContext';
import AddPumpModal from './AddPumpModal';
import './Dashboard.scss';

export default function FloatingActionButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userRole } = useAuthContext();
  const { addPump } = useStoreActions((actions) => actions.pumps);
  const [showModal, setShowModal] = useState(false);
  const fabRef = useRef(null);

  const getAnchorRect = useCallback(() => {
    if (!fabRef.current) return null;
    const r = fabRef.current.getBoundingClientRect();
    return { bottom: r.bottom, right: r.right, left: r.left, top: r.top };
  }, []);

  // Hide for roles that cannot create pumps in the UI.
  if (userRole === 3 || userRole === 4 || userRole === 5) {
    return null;
  }

  const handleSuccess = (newPump) => {
    addPump(newPump);
    setShowModal(false);
    if (newPump?.id) {
      navigate(`/dashboard/pumps/${newPump.id}`);
    }
  };

  const handleOpen = () => {
    setShowModal(true);
  };

  return (
    <>
      <button ref={fabRef} type="button" className="fab" onClick={handleOpen} aria-label={t('fab_add_pump')}>
        <i className="fas fa-plus fa-lg" />
      </button>
      
      <AddPumpModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handleSuccess}
        anchorRect={showModal ? getAnchorRect() : null}
      />
    </>
  );
} 